import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NewsDetailComponent} from '@shared/modules/shared-news-detail/components/news-detail/news-detail.component';
import {SharedVideosModule} from '@shared/modules/shared-videos/shared-videos.module';
import {LibImageModule} from '@components/image/lib-image.module';
import {LibAdsModule} from '@lib-modules/ads/lib-ads.module';
import {MatIconModule} from '@angular/material/icon';
import {InViewportModule} from 'ng-in-viewport';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SharedSpecialsModule} from '@shared/modules/shared-specials/shared-specials.module';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import {SharedGamesModule} from '@shared/modules/shared-games/shared-games.module';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {SharedCoreModule} from '@shared/shared-core.modules';
import {SharedNewsListModule} from '@shared/modules/shared-news-list/shared-news-list.module';
import {NewsDetailService} from '@shared/modules/shared-news-detail/services/news-detail.service';
import {TaboolaService} from '@shared/modules/shared-news-detail/services/taboola.service';
import {SharedWidgetsModule} from '@shared/modules/shared-widgets/shared-widgets.module';
import { LibSectionModule } from '@lib-modules/section/lib-section.module';
import { Tipp3ScriptsService } from './services/tipp3-scripts.service';

@NgModule({
  declarations: [
    NewsDetailComponent,
  ],
  imports: [
    CommonModule,
    InViewportModule,
    SharedCoreModule,
    SharedVideosModule,
    SharedSpecialsModule,
    SharedGamesModule,
    SharedNewsModule,
    SharedNewsListModule,
    LibImageModule,
    LibAdsModule,
    LibTableModule,
    LibSectionModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SharedWidgetsModule,
  ],
  providers: [
    NewsDetailService,
    TaboolaService,
    Tipp3ScriptsService,
  ]
})
export class SharedNewsDetailModule { }
